/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { CreateClusterActions, CreateClusterActionTypes, CreateClusterState } from './types';

export const initialState: CreateClusterState = {
  isOpen: false,
  serviceType: 'postgres',
  organizationId: undefined,
  projectId: undefined,
  fromBackup: false,
};

export function createCluster(state = initialState, action: CreateClusterActionTypes): CreateClusterState {
  switch (action.type) {
    case CreateClusterActions.OPEN_CREATE_CLUSTER_OVERLAY: {
      const { serviceType, organizationId, projectId, fromBackup, clusterId } = action.payload;
      return {
        ...state,
        isOpen: true,
        serviceType,
        organizationId,
        projectId,
        fromBackup,
        clusterId,
      };
    }
    case CreateClusterActions.CLOSE_CREATE_CLUSTER_OVERLAY:
      return {
        ...state,
        isOpen: false,
        serviceType: 'postgres',
        organizationId: undefined,
        projectId: undefined,
        clusterId: undefined,
      };
    default:
      return state;
  }
}
